import React from 'react';
import RemoveIcon from '../../../../../../../svg/icons/remove.svg';
import styles from './closeButton.module.pcss';

interface CloseButtonProps {
  isListerDisabled: boolean;
  facetsDisplayHandler: () => void;
}

function CloseButton({ facetsDisplayHandler, isListerDisabled }: CloseButtonProps): React.ReactElement {
  return (
    <button
      type="button"
      disabled={isListerDisabled}
      onClick={facetsDisplayHandler}
      className={styles['close-button']}
      aria-label="Close modal"
    >
      <RemoveIcon />
    </button>
  );
}

export default CloseButton;
